<template lang="pug">
  label.product-checkbox(:class="{selected: value}")
    .checkbox-wrap
      .mr-checkbox(v-if="!justForShow" :class="{selected: value}")
        input(type="checkbox" :checked="value" @change="update($event.target.checked)" :data-mr-ass="dataMrAss")
    .product-image-wrap(v-if="product && product.id")
      img.product-image.full-width(:src="product.imagery.standard.url" :alt="product.imagery.standard.alt_text")
    .product-details(v-if="product && product.id")
      span.upper.color-slate.xs-f-xsmall.max-at-tweak {{product.product_type_name}}
      span.upper.xs-f-medium.max-at-tweak {{product.name}}
      span.bold.xs-f-medium.max-at-tweak {{product.price | freeCurrency}}

</template>

<script>
  export default {
    name: "ProductCheckbox",

    props: {
      value: {
        type: [Boolean, Number]
      },

      product: {
        type: Object
      },

      justForShow: {
        type: Boolean
      },

      dataMrAss: {
        type: String
      }
    },

    methods: {
      update(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .product-checkbox
    display inline-block
    clear both
    width 100%
    padding 1em 0
    text-align left
    
    &.selected
      background-color color-mr-blue-light
    
    .checkbox-wrap
    .product-image-wrap
    .product-details
      display inline-block
      vertical-align top
    
    .checkbox-wrap
      width 2.6em
      text-align center
      
      .mr-checkbox
        margin-top 2.1em
        
    .product-image-wrap
      width 5.5em
    
    .product-details
      width 12em
      padding-left 0.75em
      padding-right 0.25em
      
      span
        display block
    
    @media mq-tablet
      .product-details
        width 14em
        
    @media mq-desktop-md-plus
      .product-details
        width 20em
        padding-left 1em
    
</style>
